import { useEffect, useState } from 'react';
import { LocalesObserver } from './localesObserver';
import { getQueryLocale, normalizeLocale } from '../../helpers';
import dayjs from 'dayjs';
import 'dayjs/locale/ar'; // Arabic
import 'dayjs/locale/de'; // German
import 'dayjs/locale/el'; // Greek
import 'dayjs/locale/es'; // Spanish
import 'dayjs/locale/fi'; // Finnish
import 'dayjs/locale/fr'; // French
import 'dayjs/locale/hi'; // Hindi
import 'dayjs/locale/hr'; // Croatian
import 'dayjs/locale/it'; // Italian
import 'dayjs/locale/ja'; // Japanese
import 'dayjs/locale/ko'; // Korean
import 'dayjs/locale/nl'; // Dutch
import 'dayjs/locale/pl'; // Polish
import 'dayjs/locale/pt'; // Portuguese
import 'dayjs/locale/ro'; // Romanian
import 'dayjs/locale/ru'; // Russian
import 'dayjs/locale/sv'; // Swedish
import 'dayjs/locale/uk'; // Ukrainian
import 'dayjs/locale/ur'; // Urdu
import 'dayjs/locale/vi'; // Vietnamese
import 'dayjs/locale/zh-cn'; // Chinese Simplified
import 'dayjs/locale/zh-tw'; // Chinese Traditional
export const PREFERRED_LOCALE_STORAGE_KEY = '[locale]preferredLocale';
const localeStore = LocalesObserver.getInstance();
const updateDocumentLang = (locale) => {
    if (typeof window !== 'undefined') {
        window.document.documentElement.lang = locale ?? 'en';
    }
};
const getPreferredLocaleData = () => {
    const preferredLocale = localStorage.getItem(PREFERRED_LOCALE_STORAGE_KEY);
    try {
        return JSON.parse(preferredLocale);
    }
    catch {
        return preferredLocale;
    }
};
export const useLocale = () => {
    const [locale, setLocale] = useState(localeStore.get());
    useEffect(() => {
        const preferredLocaleData = getPreferredLocaleData();
        const preferredLocale = Boolean(preferredLocaleData)
            ? preferredLocaleData
            : null;
        localeStore.setQueryLocal(getQueryLocale());
        localeStore.setBrowserLocale(navigator.language);
        localeStore.setPreferredLocale(preferredLocale);
        const onLocaleChange = () => {
            const currentLocale = localeStore.get();
            const formattedLocale = normalizeLocale(currentLocale);
            updateDocumentLang(formattedLocale);
            setLocale(formattedLocale);
            dayjs.locale(formattedLocale);
        };
        onLocaleChange();
        return localeStore.subscribe(onLocaleChange);
    }, []);
    return {
        locale,
        setPreferredLocale: (lang) => {
            localeStore.setPreferredLocale(lang);
            localStorage.setItem(PREFERRED_LOCALE_STORAGE_KEY, JSON.stringify(lang));
        },
    };
};
//# sourceMappingURL=useLocale.js.map